import { useToggle } from '../useToggle/useToggle.es.js';

function useVisible(initialState = false) {
  const { isActive: visible, activate: show, deactivate: hide, toggle } = useToggle(initialState);
  return { visible, show, hide, toggle };
}

export { useVisible };
//# sourceMappingURL=useVisible.es.js.map
